import { get, flatMap } from 'lodash';
/*
 discovery专用过滤器
*/
const E_QUERY_ITEM_CONDITION = {
    /** 条件必须满足所有 */
    ALL: 'all',
    /** 满足任何一个就可以 */
    ANY: 'any',
    /** none of these items */
    NONE: 'none',
};
const E_QUERY_ITEM_TYPE = {
    KEYWORD: 'keyword',
    ORGANIZATION: 'organization',
    TOPIC: 'topic',
    FIELD: 'field',
    RANGE_FIELD: 'range_field',
    GROUP: 'group', // must和嵌套时，才使用
    FIELD_EXIST: 'field_exist',
};
const E_STORE_QUERY_ITEM_TYPE = {
    KEYWORD: 'KEYWORD',
    ORG: 'ORG',
    FIELD: 'FIELD',
};
const E_STORE_VALUE_TYPE = {
    KEYWORD: 'KEYWORD',
    ORG: 'ORG',
    TOPIC: 'TOPIC',
};

const DISCOVERY_ENUM = {
    'cn': {
        'KEYWORD': '关键词',
        'ORG': '组织',
    },
    'en': {
        'KEYWORD': 'KEYWORD',
        'ORG': 'ORG',
    },
    'jp': {
        'KEYWORD': 'キーワード',
        'ORG': '組織',
    },
    'tw': {
        'KEYWORD': '關鍵詞',
        'ORG': '組織',
    }
};

//export转换器
export function queryItem2queryLayoutItem (data) {
    if (!data) {
        return '';
    }
    const condition = data.condition === E_QUERY_ITEM_CONDITION.NONE ? E_QUERY_ITEM_CONDITION.NONE : E_QUERY_ITEM_CONDITION.ANY;
    if (!data.type) {
        return [];
    }
    switch (data.type) {
        case E_QUERY_ITEM_TYPE.ORGANIZATION:
            return [
                {
                    type: E_STORE_QUERY_ITEM_TYPE.ORG,
                    condition,
                    value: data.organization.map((orgItem) => {
                        return {
                            type: E_STORE_VALUE_TYPE.ORG,
                            id: orgItem.id,
                            name: orgItem.name,
                            display_name: orgItem.display_name,
                        };
                    }),
                },
            ];
        case E_QUERY_ITEM_TYPE.KEYWORD:
            return [
                {
                    type: E_STORE_QUERY_ITEM_TYPE.KEYWORD,
                    condition,
                    value: data.value.map((valueItem) => {
                        return {
                            type: E_STORE_VALUE_TYPE.KEYWORD,
                            display_name: valueItem,
                        };
                    }),
                },
            ];
        case E_QUERY_ITEM_TYPE.TOPIC:
            return [
                {
                    type: E_STORE_QUERY_ITEM_TYPE.KEYWORD,
                    condition,
                    value: data.topic.map((topicItem) => {
                        return {
                            type: E_STORE_VALUE_TYPE.TOPIC,
                            id: topicItem.id,
                            display_name: topicItem.display_name,
                        };
                    }),
                },
            ];
        case E_QUERY_ITEM_TYPE.FIELD:
            return [
                {
                    type: E_STORE_QUERY_ITEM_TYPE.KEYWORD,
                    condition,
                    value: data.value.map((valueItem) => {
                        return {
                            type: E_STORE_VALUE_TYPE.KEYWORD,
                            display_name: valueItem,
                        };
                    }),
                },
            ];
        // email alert:同一个KEYWORD中输入的topic和keyword,存放在两个元素中
        // queryItem转成queryLayout，要将同一个KEYWORD的topic和keyword放一起，所以手动处理合并
        case E_QUERY_ITEM_TYPE.GROUP: {
            function isIncludeTopicOrKeyword (type) {
                return [E_QUERY_ITEM_TYPE.KEYWORD, E_QUERY_ITEM_TYPE.TOPIC].includes(type);
            }
            function formatTopicOrKeywordData (data) {
                // 手动处理含有topic、keyword类型的queryItem
                if (data && data.length && data.find((item) => isIncludeTopicOrKeyword(item.type))) {
                    const keywordValue = data.filter((valueItem) => valueItem.type === E_QUERY_ITEM_TYPE.KEYWORD);
                    const topicValue = data.filter((valueItem) => valueItem.type === E_QUERY_ITEM_TYPE.TOPIC);
                    // 除了keywords和topic类型之外的数据
                    const notKeywordAndTopicValue = data.filter((valueItem) => !isIncludeTopicOrKeyword(valueItem.type));

                    // 将keyword queryItem转为keyword queryLayoutItem，并提取queryLayoutItem的value
                    const keywordQueryLayoutValue = flatMap(flatMap(keywordValue, queryItem2queryLayoutItem), (item) => item.value);
                    // topic queryItem转为topic queryLayoutItem，并提取queryLayoutItem的value
                    const topicQueryLayoutValue = flatMap(flatMap(topicValue, queryItem2queryLayoutItem), (item) => item.value);
                    return {
                        keywordOrTopicValue: [...keywordQueryLayoutValue, ...topicQueryLayoutValue],
                        notKeywordAndTopicValue,
                    };
                }
                return null;
            }
            // format data.any
            const anyData = formatTopicOrKeywordData(data.any);
            // format data.must
            const mustData = formatTopicOrKeywordData(data.must);
            let rt = [];
            if (anyData) {
                rt = rt.concat([
                    ...flatMap([...(data.must || []), ...(data.filter || []), ...anyData.notKeywordAndTopicValue], queryItem2queryLayoutItem),
                    {
                        // 组装topic和keyword的queryLayout
                        condition,
                        type: E_STORE_QUERY_ITEM_TYPE.KEYWORD,
                        value: anyData.keywordOrTopicValue,
                    },
                ]);
            }
            if (mustData) {
                rt = rt.concat([
                    ...flatMap([...(data.any || []), ...(data.filter || []), ...mustData.notKeywordAndTopicValue], queryItem2queryLayoutItem),
                    {
                        // 组装topic和keyword的queryLayout
                        condition,
                        type: E_STORE_QUERY_ITEM_TYPE.KEYWORD,
                        value: mustData.keywordOrTopicValue,
                    },
                ]);
            }
            if (rt.length) {
                return rt;
            }
            // queryItem中不含topic、keyword，则直接处理
            return flatMap([...(data.must || []), ...(data.any || [])], queryItem2queryLayoutItem);
        }
        case E_QUERY_ITEM_TYPE.FIELD_EXIST:
            return [];
        case E_QUERY_ITEM_TYPE.RANGE_FIELD:
            return [];
    }
}

//search转换器
export function queryLayoutItem2Text (data) {
    if (!data) {
        return '';
    }
    function getDisplayName (data) {
        return `${data.display_name}`;
    }
    function getName (data) {
        return data.name ? `${data.name}` : `${data.display_name}`;
    }
    function getConditionName (condition) {
        return condition === E_QUERY_ITEM_CONDITION.NONE ? '<span class="history-or">NOT</span>' : '<span class="history-or">AND</span>';
    }
    const onlyOrLogic = data.filter((ele) => ele.value && ele.value.length).length <= 1;
    return data.reduce((acc, curr, index) => {
        const conditionText =
            index === 0 ? (curr.condition === E_QUERY_ITEM_CONDITION.NONE ? getConditionName(curr.condition) : '') : getConditionName(curr.condition);

        let valueText = '';
        switch (curr.type) {
            case E_STORE_QUERY_ITEM_TYPE.KEYWORD:
                valueText = curr.value.map(getName).join(' <span class="history-or">OR</span> ');
                break;
            case E_STORE_QUERY_ITEM_TYPE.ORG:
                valueText = curr.value.map(getName).join(' <span class="history-or">OR</span> ');
                break;
            case E_STORE_QUERY_ITEM_TYPE.FIELD:
                valueText = curr.value.map(getDisplayName).join(' <span class="history-or">OR</span> ');
                break;
        }
        const orLen = curr.value.length;
        const currentText = onlyOrLogic ? `${conditionText} ${valueText}` : `${conditionText} ${orLen > 1 ? `(${valueText})` : valueText}`;
        return `${acc} ${currentText}`;
    }, '');
}

export function dataExplorerItem2Text (data = {}) {
    const { query_type, value } = data;
    const valueText = value?.join?.(' <span class="history-or">OR</span> ') ?? '';

    return `${query_type === 'TECH' ? 'SIGNALS' : query_type}:(${valueText})`;
}

export function item2Text (item) {
    const dataExplorerQueryType = get(item, 'search_request.query.must[0].any[0].query_type');

    if (dataExplorerQueryType) {
        return dataExplorerQueryType === 'ALL' ? '' : dataExplorerItem2Text(get(item, 'search_request.query.must[0].any[0]'));
    } else {
        return item.search_request && item.search_request.query
            ? queryLayoutItem2Text(queryItem2queryLayoutItem(item.search_request.query))
            : '';
    }
}